import { render, staticRenderFns } from "./indexH5.vue?vue&type=template&id=f172b112&scoped=true"
import script from "./indexH5.vue?vue&type=script&setup=true&lang=ts"
export * from "./indexH5.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./indexH5.vue?vue&type=style&index=0&id=f172b112&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f172b112",
  null
  
)

export default component.exports